import React from "react";
import classNames from "classnames";

import { MenuItem, Tooltip, Position } from "@blueprintjs/core";

import styles from "./SidebarItem.module.scss";
import { Icon } from "../../atoms/Icon";

function SidebarItem({ active, icon, label, collapsed, onClick }) {
  return collapsed ? (
    <Tooltip
      hoverOpenDelay={500}
      minimal
      content={label}
      position={Position.RIGHT_TOP}
    >
      <MenuItem
        className={classNames(styles.sidebarItem, active && styles.isActive)}
        active={active}
        icon={<Icon name={icon} size={16} className={styles.sidebarItemIcon} />}
        onClick={onClick}
      />
    </Tooltip>
  ) : (
    <MenuItem
      className={classNames(styles.sidebarItem, active && styles.isActive)}
      active={active}
      icon={<Icon name={icon} size={16} className={styles.sidebarItemIcon} />}
      label={<span className={styles.label}>{label}</span>}
      onClick={onClick}
    />
  );
}

export default SidebarItem;
